import { render } from "./ChatBodyHead.vue?vue&type=template&id=0411963a&scoped=true"
import script from "./ChatBodyHead.vue?vue&type=script&lang=js"
export * from "./ChatBodyHead.vue?vue&type=script&lang=js"

import "./ChatBodyHead.vue?vue&type=style&index=0&id=0411963a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0411963a"],['__file',"webpack-assets/vue/templates/chat/parts/ChatBodyHead.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0411963a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0411963a', __exports__)) {
    api.reload('0411963a', __exports__)
  }
  
  module.hot.accept("./ChatBodyHead.vue?vue&type=template&id=0411963a&scoped=true", () => {
    api.rerender('0411963a', render)
  })

}


export default __exports__